module.exports = __webpack_public_path__ + "img/laptop-solid.e19b145f.svg";